import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { RallyRound } from '@/lib/models/RallyRound'
import { RallyRoundHeaderImage } from '@/lib/models/RallyRoundHeaderImage'

@Module
export class PageURLRallyRound extends VuexModule {
    public rallyRound: RallyRound = new RallyRound()

    @Mutation
    public updateRallyRound (rallyRound: RallyRound) {
      this.rallyRound = rallyRound
    }

    @Action({ commit: 'updateRallyRound', rawError: true })
    public async loadRallyRound (rallyRoundId?: number) {
      if (!this.rallyRound.id || this.rallyRound.id !== rallyRoundId) {
        const urlParams = new URLSearchParams(window.location.search)
        const pageUrlRallyRoundId = parseInt(urlParams.get('rrid') ?? '0')
        if ((rallyRoundId ?? pageUrlRallyRoundId) !== 0) {
          return await RallyRound.get(
            rallyRoundId ?? pageUrlRallyRoundId,
            [{ subclassInstance: RallyRoundHeaderImage, subclassPath: 'headerImage' }]
          )
        } else {
          return this.rallyRound
        }
      } else {
        return this.rallyRound
      }
    }

    @Action({ commit: 'updateRallyRound', rawError: true })
    public async forceReloadRallyRound (rallyRoundId?: number) {
      const urlParams = new URLSearchParams(window.location.search)
      const pageUrlRallyRoundId = parseInt(urlParams.get('rrid') ?? '0')
      return await RallyRound.get(
        rallyRoundId ?? pageUrlRallyRoundId,
        [{ subclassInstance: RallyRoundHeaderImage, subclassPath: 'headerImage' }]
      )
    }
}
